import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

/**
 * Scroll to the anchor after page load.
 */
export const useAnchor = () => {

  const loc = useLocation()

  useEffect(() => {
    if (loc.hash) {
      const element = document.getElementById(loc.hash.substring(1))
      if (element) {
        window.scrollTo({
          top: element.offsetTop - 15,
          behavior: 'smooth'
        })
      }
    }
  }, [loc.hash])
}
